import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { Create, FormManager, PageTitle } from 'gossamer-front-end';
import { getListRowLink } from 'gossamer-unified';
import { Institution } from 'cb-model';

export const InstitutionCreate = (): React.JSX.Element => {
  const navigate = useNavigate();
  return (
    <>
      <PageTitle verb="Create" entity={Institution} />
      <FormManager
        compoundUrl="/main/~/institution-create"
        handleCancel={() => navigate(`/admin/institution/search`)}
        handleSuccess={({ keyOfFirstCreate }) => navigate(getListRowLink(Institution.listRowLink, keyOfFirstCreate))}
        initialization={{
          main: { type: 'create-single', entity: Institution },
        }}
      >
        <Create valuesKey="main" entity={Institution} />
      </FormManager>
    </>
  );
};
